export default function deepObjectKeyPut(obj, prop, value) {

  if(typeof obj === "undefined") {
    return false;
  }

  let _index = prop.indexOf(".");
  if(_index > -1) {
    deepObjectKeyPut(obj[ prop.substring(0, _index) ], prop.substr(_index + 1), value);
  } else {
    obj[ prop ] = value;
  }
}
